<template>
    <card>
        <card-header>
            <card-overline>Lieferverzögerung</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>P-Nr.</th>
                    <th>Eingangsdatum</th>
                    <th>neuer P-Liefertermin</th>
                    <th>Grund</th>
                    <th>korr. P-Liefertermin</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="producerLateDelivery in producerLatedeliveries" :key="producerLateDelivery.index">
                    <td>{{ producerLateDelivery.producer_user.prod_no }}</td>
                    <td>{{ this.$date(producerLateDelivery?.created_at) }}</td>
                    <td>{{ this.$date(producerLateDelivery?.new_delivery_date) }}</td>
                    <td>{{ producerLateDelivery.reason }}</td>
                    <td>{{ producerLateDelivery?.corrected_delivery_date ? this.$date(producerLateDelivery?.corrected_delivery_date) : '-' }}</td>
                    <td>
                        <form-button icon="pen-edit" dense="true" @click="selectedProducerLateDelivery = producerLateDelivery; producerLateDeliveryModal = true; "/>
                    </td>
                </tr>
                </tbody>
            </table>
            <producer-late-delivery-modal v-if="producerLateDeliveryModal" :producer-late-delivery="selectedProducerLateDelivery" :ask-for-quote="askForQuote" @closeDialog="producerLateDeliveryModal = false; selectedProducerLateDelivery = null;" />
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ProducerLateDeliveryModal from '@partfactory/Pages/Admin/AskForQuote/Modals/ProducerLateDeliveryModal';
export default {
    name: 'ProducerLateDeliveries',
    components: {ProducerLateDeliveryModal, FormButton, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
    },
    data() {
        let producerLateDeliveryModal = false, selectedProducerLateDelivery = null;

        return {producerLateDeliveryModal, selectedProducerLateDelivery};
    },
    computed: {
        producerLatedeliveries() {
            return this.askForQuote?.producer_order?.producer_late_deliveries;
        }
    }
};
</script>
